export enum PreprintModerationTab {
  Submissions = 'submissions',
  WithdrawalRequests = 'withdrawals',
  Moderators = 'moderators',
  Notifications = 'notifications',
  Settings = 'settings',
}
